// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  InvestorPledgedCardRow,
  InvestorTransactAccountRow,
  InvestorInvestmentRow,
  InvestorNominatedBusinessRow,
  InvestorPledgedNominationRow,
} from "./types";


export default __t.row({
  get pledgedCards() {
    return __t.array(InvestorPledgedCardRow).name("pledged_cards");
  },
  get transactAccount() {
    return __t.option(InvestorTransactAccountRow).name("transact_account");
  },
  get investments() {
    return __t.array(InvestorInvestmentRow);
  },
  get nominatedBusinesses() {
    return __t.array(InvestorNominatedBusinessRow).name("nominated_businesses");
  },
  get pledgedNominations() {
    return __t.array(InvestorPledgedNominationRow).name("pledged_nominations");
  },
});
